/**
 * @generated SignedSource<<44303b94d07299f27c191f2263a9d40a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueTable_nativeIssueTable_rankField$data = {
  readonly " $fragmentSpreads": FragmentRefs<"groupTableBody_nativeIssueTable_rankField" | "tableBody_nativeIssueTable_rankField">;
  readonly " $fragmentType": "issueTable_nativeIssueTable_rankField";
};
export type issueTable_nativeIssueTable_rankField$key = {
  readonly " $data"?: issueTable_nativeIssueTable_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueTable_nativeIssueTable_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueTable_nativeIssueTable_rankField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "tableBody_nativeIssueTable_rankField"
    },
    {
      "kind": "FragmentSpread",
      "name": "groupTableBody_nativeIssueTable_rankField"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "744dcf6aed2e3628cba0d01e183b9af5";

export default node;
